export const hasServerError = (errorCode) =>
  errorCode && [400, 403, 500, 503].includes(errorCode);
